'use client';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import FormText from '../../../../components/form/FormText/FormText';
import FaIcon from '../../../../components/icon/FaIcon/FaIcon';
import PageHeader from '../../../../components/layouts/PageHeader/PageHeader';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import styles from './LotteryListHeader.module.scss';

export type LotteryListHeaderProps = {
  query?: string;
  pageTitle?: string;
  placeholder?: string;
  onSearch: (searchText: string) => void;
};

function LotteryListHeader({
  query,
  pageTitle = 'オンラインくじ一覧',
  placeholder = 'イベント名を検索できます',
  onSearch,
}: LotteryListHeaderProps) {
  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      searchText: query || '',
    },
  });

  const handleSearch = () => {
    const searchText = getValues('searchText');
    onSearch(searchText);
  };

  return (
    <>
      <div className={styles.header}>
        <PageHeader text={pageTitle} />
        <div className={styles.textSearchWrapper}>
          <form onSubmit={handleSubmit(handleSearch)}>
            <FormText
              name='searchText'
              control={control}
              outlined
              placeholder={placeholder}
              prefix={
                <div className={styles.searchIcon}>
                  <FaIcon icon={faSearch} size='xl' />
                </div>
              }
              onChange={handleSearch}
              isSmall={true}
            />
          </form>
        </div>
      </div>

      <div className={styles.searchArea}>
        {query && (
          <div className={utilsStyles.mtXSmall}>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>"{query}"の検索結果</p>
          </div>
        )}
      </div>
    </>
  );
}

export default LotteryListHeader;
